import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loginVisible: false,
        registerVisible: false,
        findPasswordVisible: false,
        userInfo: {},
        isLogin: false,
        modifyPwdVisible: false,
    },
    mutations: {
        openLogin(state) {
            state.loginVisible = true;
        },
        closeLogin(state) {
            state.loginVisible = false;
        },
        openRegister(state) {
            state.registerVisible = true;
        },
        closeRegister(state) {
            state.registerVisible = false;
        },
        openFindPassword(state) {
            state.findPasswordVisible = true;
        },
        closeFindPassword(state) {
            state.findPasswordVisible = false;
        },
        setUserInfo(state, data) {
            state.userInfo = data;
            this.commit("isLogin");
        },
        isLogin(state) {
            if (state.userInfo.__usersession_uuid) {
                state.isLogin = true;
            } else {
                state.isLogin = false;
            }
        },
        openModifyPwd(state) {
            state.modifyPwdVisible = true;
        },
        closeModifyPwd(state) {
            state.modifyPwdVisible = false;
        }
    },
    getters: {
        loginDialog: (state) => {
            return state.loginVisible;
        },
        registerDialog: (state) => {
            return state.registerVisible;
        },
        isLogin: (state) => {
            return state.isLogin;
        },
        modifyPwdDialog: (state) => {
            return state.modifyPwdVisible;
        },
    },
    actions: {},
    modules: {},
});
